import FqApi from '@/services/fq-api'
const baseUrl = '/quotes/mobileimages'

export default {
  async getQuoteByImageHyperlinkId(quoteImageHyperlinkId) {
    const result = await FqApi.get(`${baseUrl}/quotebyimagehyperlinkid/${encodeURIComponent(quoteImageHyperlinkId)}`)
    return result.data
  },
  async getQuoteImageCategories(companyId) {
    const url = `${baseUrl}/categories/list?companyId=${encodeURIComponent(companyId)}`
    return (await FqApi.get(url)).data
  },
  async getQuoteVehicleById(companyId,vehicleId) {
    const result = await FqApi.get(`${baseUrl}/quotevehiclebyid/${encodeURIComponent(companyId)}/${encodeURIComponent(vehicleId)}`)
    return result.data
  },
  async getImageIdsWithCategory(quoteId, categoryId) {
    const url = `${baseUrl}/imageidswithcategory/${quoteId}/${categoryId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getImageThumbnailWithInfo(id, size) {
    const url = `${baseUrl}/imagesthumbnailinfo/${id}?size=${size}`
    const result = await FqApi.get(url)
    result.data.imageContent = `data:${result.data.mimeType};base64,${result.data.imageContent}`
    return result.data
  },
  async deleteImage(id) {
    const url = `${baseUrl}/imagesdelete/${id}`
    const result = await FqApi.delete(url)
    return result
  },
  async getImageThumbnail(id, size) {
    const url = `${baseUrl}/imagesthumbnail/${id}?size=${size}`
    const result = await FqApi.get(url, { responseType: 'arraybuffer' })
    const image = Buffer.from(result.data, 'binary').toString('base64')
    return `data:${result.headers['content-type'].toLowerCase()};base64,${image}`
  }
}
